"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var fleet_location_const_1 = require("./fleet-location.const");
/**
 * FleetLocationService
 * @class
 */
var FleetLocationService = /** @class */ (function () {
    function FleetLocationService() {
    }
    /**
     * Returns an array of cities available for a clients app
     * @returns Location[]
     */
    FleetLocationService.prototype.getCities = function (version) {
        if (version === void 0) { version = 'v1'; }
        var url = fleet_location_const_1.FLEET_LOCATION_ENDPOINT.getCities.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns an array of Locations for a given city (`cityUuid`)
     * @param cityUuid {string}
     * @returns Location[]
     */
    FleetLocationService.prototype.getLocations = function (cityUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = fleet_location_const_1.FLEET_LOCATION_ENDPOINT.getLocations
            .replace('{{version}}', version)
            .replace('{{cityUuid}}', cityUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a details of a given location (`locationUuid`)
     * @param location {string}
     * @returns LocationDetails
     */
    FleetLocationService.prototype.getLocationDetails = function (locationUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = fleet_location_const_1.FLEET_LOCATION_ENDPOINT.getLocationDetails
            .replace('{{version}}', version)
            .replace('{{locationUuid}}', locationUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a spots of a given city (`cityUuid`)
     * @param location {string
     * @returns LocationDetails
     */
    FleetLocationService.prototype.getSpotsUrl = function (cityUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = fleet_location_const_1.FLEET_LOCATION_ENDPOINT.getSpotsUrl
            .replace('{{version}}', version)
            .replace('{{cityUuid}}', cityUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    return FleetLocationService;
}());
/**
 * External FleetLocationService Class Instance
 * @namespace
 */
exports.fleetLocation = new FleetLocationService();
